export enum GatheringType {
  Class = "Class",
  Festival = "Festival",
  Workshop = "Workshop",
  Retreat = "Retreat",
  Training = "Training",
  Jam = "Jam",
}
